export function HeroBackdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      <picture>
        <source media="(max-width: 640px)" srcSet="/marketing/meadow-4-mobile.jpg" />
        <img
          src="/marketing/meadow-4.jpg"
          alt=""
          width={2400}
          height={1343}
          fetchPriority="high"
          className="h-full w-full object-cover object-[62%_center] md:object-center"
        />
      </picture>
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(10,13,12,0.82),rgba(10,13,12,0.42)_55%,rgba(10,13,12,0.12))]" />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,13,12,0.35),transparent_30%,rgba(10,13,12,0.15)_65%,#101112)]" />
    </div>
  );
}
